import { Expose } from 'class-transformer';

import { SnModel } from '../../../../common/src/lib/models/model';
import { AxonNotificationModel } from './axon-notification.model';

export class AxonAttributesModel extends SnModel {
  @Expose()
  public timestamp: number;

  @Expose()
  public category: string;

  @Expose()
  public device: {
    deviceId: string;
    deviceType: string;
  };

  @Expose()
  public level: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}

export class AxonEventModel extends SnModel {
  @Expose()
  public attributes: AxonAttributesModel;

  @Expose()
  public type: string;

  @Expose()
  public id: AxonNotificationModel;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
